module.exports = __webpack_public_path__ + "img/ICTtraining.92150434.jpeg";